<template>
  <div class="content-box">
    <div
      class="support-index"
      :class="{ 'show-ticket-content': posicionselect != null }"
    >
      <div class="support-tickets">
        <div class="support-tickets-header">
          <div class="tickets-control">
            <h5>Inventario en Posiciones</h5>
          </div>
        </div>
        <div class="row">
          Tipo Posición
          <div class="col-7">
            <select
              class="form-control form-control-sm bright"
              v-model="filtro_estado"
              @change="refreshPosiciones"
            >
              <option value>TODOS</option>
              <option value="P">POSICIÓN</option>
              <option value="C">CARRITO</option>
              <option value="E">ESTACIÓN</option>
            </select>
          </div>
          <div class="row">
            <div class="col-4">
              <br />
            </div>
            <div class="row">
              <div class="col-7">
                <TiendaSelectComponent
                  @change="refreshPosiciones"
                  :current="tienda_filtro"
                />
              </div>
              <button
                type="button"
                class="btn btn-sm btn-dark"
                @click="refreshPosiciones"
                disabled
              >
                Imprimir Barras
              </button>
            </div>
          </div>
        </div>
        <br />

        <InventarioPorPosicionesTicketComponent
          v-for="current in posiciones"
          v-bind:key="current.id"
          :current="current"
          @onTicketClick="seleccionarPosicion(current)"
        />
      </div>
      <InventarioPorPosicionesContentComponent
        v-if="posicionselect != null"
        :current="posicionselect"
        @regresar="regresar"
        @seleccionarPosicion="seleccionarPosicion"
      />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import InventarioPorPosicionesTicketComponent from "@/components/wms/dashboard/InventarioPorPosicionesTicketComponent";
import InventarioPorPosicionesContentComponent from "@/components/wms/dashboard/InventarioPorPosicionesContentComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import AbrirTarimaComponentVue from "../tarimas/AbrirTarimaComponent.vue";

export default {
  components: {
    UsuarioEnTablaComponent,
    InventarioPorPosicionesTicketComponent,
    InventarioPorPosicionesContentComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      tienda_filtro: {},
      current: {
        estado: "A",
      },
      posiciones: [],
      posicionselect: [],
      id_tarima: null,
      filtro_estado: "P",
    };
  },
  mounted() {
    this.refreshPosiciones();
  },
  methods: {
    refreshPosiciones() {
      let self = this;
      DynamicService.fetch("inv", "posiciones", {
        quitar_paginacion: true,
        tipo_posicion: self.filtro_estado,
        tienda: self.tienda_filtro.tienda,
      }).then((resp) => {
        self.posiciones = resp.data;
      });
    },
    seleccionarPosicion(current) {
      let self = this;
      DynamicService.getAction("inv", "posiciones", current.id, "inventario")
        .then((res) => {
          self.posicionselect = res.data;
        })
        .catch((err) => {});
    },
    regresar() {
      this.refreshPosiciones();
      this.posicionselect = null;
      this.id_tarima = null;
    },
  },
};
</script>
